<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "reconcile-wrapper"
};
</script>

<style>
</style>